<template>
  <div class="d-flex">
    <v-chip
      v-for="(n) in levelOfGuidances"
      :key="n + 1"
      :outlined="activeLevelOfGuidance !== n + 1"
      class="level-of-guidance-indicators__circle"
      color="primary"
    >
      {{ n + 1 }}
    </v-chip>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

/**
 * Component LevelOfGuidanceIndicator.vue
 *
 * @module LevelOfGuidanceIndicator
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.5] app/src/APP_DASHBOARD/templates/components/Parts/LevelOfGuidanceIndicator.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: "LevelOfGuidanceIndicator",
  props: ['behaviourComponent'],
  computed: {
    ...mapGetters({
      behaviourComponents: 'patientSummary/behaviourComponents',
    }),
    levelOfGuidances() {
      switch(this.behaviourComponent) {
        case 'MEDICATIONS':
          return Array.from(Array(2).keys());
        default:
          return Array.from(Array(3).keys());
      }
    },
    activeLevelOfGuidance() {
      const _behaviourComponent = this.$store.state.patientSummary.behaviourComponents
        .find(item => item.key === this.behaviourComponent);

      return _behaviourComponent?.levelOfGuidance || 0
    }
  }
};
</script>

<style lang="scss">
.level-of-guidance-indicators__circle {
  border-radius: 50% !important;
  width: 36px;
  height: 36px !important;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
